import React, { FC, useMemo } from 'react'

import { ambassadorHttpClient } from '../../../api/httpClient'
import { BusinessTermService } from '../../reusable/Category/api/BusinessTermService'
import { EasierCategory as EasierCategoryUnwrapped } from './EasierCategory'

export const EasierCategory: FC = () => {
  const businessTermService = useMemo(() => new BusinessTermService(ambassadorHttpClient), [])
  return <EasierCategoryUnwrapped businessTermService={businessTermService} />
}
